export default {"src":"/_next/static/media/Step2.3c90de36.svg","height":254,"width":605,"blurWidth":0,"blurHeight":0};